<template>
  
  <div>

    <div class="ui large breadcrumb">
      <a class="clickable" @click="goBack()">
        <i class="reply icon m-r-5"></i> Serviços
      </a>
      <i class="right chevron icon divider"></i>
      <div class="section">
        <strong>{{ isCreating ? creatingTitle : updatingTitle }}</strong>
      </div>
    </div>

    <bookmark-button v-if="isCreating" :label="creatingTitle" />

    <div class="ui divider"></div>

    <div v-if="loading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

    <div v-show="!loading" class="animated fadeIn">

      <div class="ui segment">
        <h4 class="ui dividing header">Dados do Serviço</h4>
        <div class="ui form">          
          <div class="fields">
            <div class="eight wide field">
              <label class="form-label">Nome <span class="red text">*</span></label>
              <input class="uppercase" v-model="service.description" @blur="service.description = $toUpperCase($event)">
            </div>                                                            
          </div>          
        </div>
      </div>  

      <div class="ui segment form-segment" :class="{ loading: checkingType }">

        <h4 class="ui dividing header">Tipos</h4>

        <button class="ui mini basic button" @click="$refs.typeModal.create()">
          <i class="plus blue icon"></i> Adicionar
        </button>
        
        <table v-if="hasTypes" class="ui celled selectable tablet stackable table animated fadeIn">
          <thead v-if="$isDesktop">
            <tr>
              <th>Descrição</th>
              <th>Ícone</th>
              <th>% Colaborador</th>
              <th></th>
            </tr>  
          </thead>
          <tbody>
            <tr v-if="!type.removed" v-for="(type, index) in service.types" @click="onTypeClick(index)">              
              <td>
                <strong class="mobile-only">Descrição: </strong> {{ $truncateString(type.description, 170) }}  
              </td>                          
              <td>
                <strong class="mobile-only">Ícone: </strong>
                <service-type-icon :icon="type.icon" :showDescription="true" />
              </td>  
              <td>
                <strong class="mobile-only">% Colaborador: </strong>
                {{ $formatCurrency(type.employeeFee) }}
              </td>                   
              <td style="width: 50px;">
                <button class="ui small icon button" @click="onRemoveType($event, index)">
                  <i class="times icon"></i>
                </button>
              </td>
            </tr>                
          </tbody>
        </table>

        <p v-else class="grey text m-t-20 animated fadeIn">
          <i class="info circle icon"></i> Nenhum tipo adicionado
        </p>

      </div>

      <div class="m-t-20">
        <button class="ui basic button" @click="goBack()">
          <i class="reply icon"></i> Cancelar
        </button>
        <button v-if="isUpdating" class="ui basic red button m-l-10" 
          :class="{ loading: checkingRemoval || removing, disabled: saving }" @click="onRemove()">
          <i class="trash icon"></i> Excluir
        </button> 
        <button class="ui right floated blue button" :class="{ loading: saving }" @click="onConfirm()">
          <i class="check icon"></i> {{ isCreating ? 'Confirmar' : 'Atualizar' }}
        </button>         
      </div>

      <type-modal ref="typeModal" @onCreate="onAddType" @onUpdate="onUpdateType" />

      <can-not-remove-modal ref="canNotRemoveModal" />

      <yes-no-modal ref="confirmRemovalModal" danger="true"
        :message="`Confirma exclusão do serviço ${service.name} ?`"  @onYes="onConfirmRemoval()" />

    </div>  

  </div>

</template> 

<script>

  import { formPage, onlySimavet } from "@/mixins"
  import SrvService from "@/services/srv-service"
  import ServiceTypeIcon from "@/components/service-type-icon"
  import TypeModal from "./type-modal"  

  export default {
    
    name: "ServiceForm",

    mixins: [formPage, onlySimavet],

    data() {
      return {
        indexRoute: "/entries/services",
        creatingTitle: "Novo Serviço",
        updatingTitle: "Alterar Serviço",
        srv: new SrvService(),
        service: { types: [] },  
        selectedTypeIndex: null,    
        checkingType: false,  
      }
    },    

    components: { 
      TypeModal,
      ServiceTypeIcon,
    },

    mounted() {

      if (this.isUpdating)
        this.loadService()      
    },

    computed: {

      hasTypes() {

        let exists = false

        for (let type of this.service.types) {
          if (!type.removed) {
            exists = true
            break
          }  
        }

        return exists
      },
    },

    methods: {

      async loadService() {

        this.loading = true

        try {

          this.service = await this.srv.findById(this.$route.params.id)

        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.loading = false
        }
      },

      onTypeClick(index) {

        this.selectedTypeIndex = index
        
        this.$refs.typeModal.update(this.service.types[index])
      },

      onAddType(type) {
        this.service.types.push(type)
      },  

      onUpdateType(type) {

        let types = this.service.types.slice()

        types[this.selectedTypeIndex] = type

        this.service.types = types.slice()
      },

      async onRemoveType($event, index) {

        $event.stopPropagation()

        this.checkingType = true

        try {          

          let types = this.service.types.slice()

          if (this.isUpdating) {

            const canRemove = await this.srv.canRemoveServiceType(types[index].id)
            
            if (!canRemove) {
              this.checkingType = false
              this.$msg.info("Esse tipo de serviço não pode ser excluído porque já foi utilizado em um laudo")
              return
            }
          }                  

          types[index].removed = true

          this.service.types = types
          
        } catch (error) {
          
          this.$errorHandler(error)

        } finally {

          this.checkingType = false
        }
      },

      async onConfirm() {

        if (!this.validData())
          return

        this.saving = true

        try {

          if (this.isCreating) {
            await this.srv.create(this.service)
          } else {
            await this.srv.update(this.service)
          }

          this.$reloadDataTables()

          this.$msg.success(this.isCreating ? "Serviço criado com sucesso" : "Serviço atualizado com sucesso")

          this.goBack()

        } catch (error) {

          this.saving = false

          this.$errorHandler(error)
        }
      },

      validData() {

        let isOk = true
        let message = ""

        if (!this.service.description) {
          message = "Informe a descrição do serviço"
        } else if (!this.hasTypes) {
          message = "Adicione ao menos um tipo de serviço"
        }

        if (message) {
          isOk = false
          this.$msg.info(message)
        }

        return isOk
      },

      async onRemove() {

        this.checkingRemoval = true

        try {

          const data = await this.srv.canRemove(this.service)

          if (data.canRemove)  {
            this.$refs.confirmRemovalModal.show()              
          } else {
            this.$refs.canNotRemoveModal.show(data.entities)            
          }

        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.checkingRemoval = false
        }        
      },

      async onConfirmRemoval() {
        
        this.removing = true

        try {

          await this.srv.remove(this.service)

          this.$reloadDataTables()

          this.$msg.success("Serviço excluído com sucesso")

          this.goBack()

        } catch (error) {

          this.removing = false

          this.$errorHandler(error)
        }
      },
    },
  }

</script>